module.exports = __webpack_public_path__ + "static/img/sunwoospring-csr.f8585e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/sunwoospring-csr.jpg
// module id = 9qFa
// module chunks = 0